
import { canv } from '@/canv/global.js'
import { drawRoundedRect, isOverRect } from '@/canv/utils.js'

export class cardWidgetStatusBarCheckBox {

    constructor(startX, startY, width, height) {
        this.startX = startX;
        this.startY = startY;
        this.width = width;
        this.height = height;
    }


    updateCoords(startX, startY) {
        this.startX = startX;
        this.startY = startY;
    }

    setIsChecked(isChecked) {
        this.isChecked = isChecked;
    }



    // draw

    draw() {
        let memGlobalAlpha = canv.ctx.globalAlpha;

        drawRoundedRect(this.startX, this.startY, this.width, this.height, 8);

        canv.ctx.lineWidth = 2;

        if (this.isChecked) {
            canv.ctx.strokeStyle = "#71BE38";
            canv.ctx.stroke();
        } else {
            canv.ctx.strokeStyle = "#D9D9D9";
            canv.ctx.stroke();

            if (this.fillOpacity == 0 && isOverRect(this.startX, this.startY, this.width, this.height)) {
                canv.ctx.fillStyle = "#FAFAFA";
                canv.ctx.fill();
            }
        }


        if (this.isChecked && this.fillOpacity < this.fillOpacityConst) {
            this.fillOpacity++;
            canv.redraw();
        }

        if (!this.isChecked && this.fillOpacity > 0) {
            this.fillOpacity--;
            canv.redraw();
        }


        canv.ctx.globalAlpha = this.fillOpacity / this.fillOpacityConst;
        canv.ctx.fillStyle = "#71BE38";
        canv.ctx.fill();

        this.drawCheck();

        canv.ctx.globalAlpha = memGlobalAlpha;

    }

    drawCheck() {
        // width == height

        canv.ctx.beginPath();

        let sdvigX = 0.0909 * this.width; // чтобы левый край касался границы box
        let sdvigY = 0.0909 * this.height;// чтобы верхний край касался границы box
        let checkWidth = 0.4545 * this.width;
        let checkHeight = 0.3030 * this.height;
        let sdvigXToCenter = -sdvigX + this.width/2 - checkWidth/2;
        let sdvigYToCenter = -sdvigY + this.height/2 - checkHeight/2;
        canv.ctx.moveTo(this.startX + 0.0909 * this.width + sdvigXToCenter, this.startY + 0.2424 * this.height + sdvigYToCenter);
        canv.ctx.lineTo(this.startX + 0.2424 * this.width + sdvigXToCenter, this.startY + 0.3939 * this.height + sdvigYToCenter);
        canv.ctx.lineTo(this.startX + 0.5454 * this.width + sdvigXToCenter, this.startY + 0.0909 * this.height + sdvigYToCenter);

        canv.ctx.lineCap = "round";
        canv.ctx.lineWidth = 3;
        canv.ctx.strokeStyle = "#FFFFFF";
        canv.ctx.stroke();
        canv.ctx.closePath();

    }


    startX = 0;
    startY = 0;
    width = 0;
    height = 0;

    isChecked = false;
    fillOpacity = 0;
    fillOpacityConst = 20;
}











